import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51c901e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled", "autofocus", "type"]
const _hoisted_2 = {
  key: 0,
  class: "el-icon-loading"
}
const _hoisted_3 = {
  key: 2,
  class: "flex items-center justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
      'el-button ms-button',
      _ctx.type ? 'el-button--' + _ctx.type : '',
      _ctx.buttonSize ? 'el-button--' + _ctx.buttonSize : '',
      _ctx.themeCls ? 'el-button--' + _ctx.themeCls : '',
      {
        'is-disabled': _ctx.buttonDisabled,
        'is-loading': _ctx.loading,
        'is-plain': _ctx.plain,
        'is-round': _ctx.round,
        'is-circle': _ctx.circle,
        'active': _ctx.isActive
      },
    ]),
    disabled: _ctx.buttonDisabled || _ctx.loading,
    autofocus: _ctx.autofocus,
    type: _ctx.nativeType,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("i", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.icon && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: _normalizeClass(_ctx.icon)
        }, null, 2))
      : _createCommentVNode("", true),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}